exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media (max-width:37.4rem){.style_hide-sm__n_Ecp{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__P2EKE{display:none!important}}@media (max-width:79.9rem){.style_hide-md__2DPYJ{display:none!important}}@media (min-width:79.9rem){.style_visible-md__2OHkK{display:none!important}}.style_paperContent__382gV{box-shadow:0 .0625rem .1875rem 0 rgba(0,0,0,.2),0 .125rem .125rem 0 rgba(0,0,0,.12),0 0 .125rem 0 rgba(0,0,0,.14);background-color:#fff;margin:0 0 1rem}.style_paperContent__382gV,.style_paperContentFlat__QSsBj{width:100%;max-width:1280px;position:relative;display:flex;align-items:stretch;flex-direction:column}.style_paperContentFlat__QSsBj{box-shadow:0;background-color:transparent;margin:0 1rem}@media (max-width:37.4rem){.style_paperContentFlat__QSsBj{margin:.8rem}}.style_paperFullWidth__8SfP3{max-width:none}.style_container__23_qZ{display:flex;width:100%;justify-content:center}.style_headerContainer__1Wp7n{background:#fff}.style_busyFromPromise__m7JN_{width:100%}.style_title__1zL1H{word-wrap:break-word;background-color:#fff}.style_stickied__3AmB4{box-shadow:0 .0625rem .1875rem -.0625rem rgba(0,0,0,.34)}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__n_Ecp",
	"hideSm": "style_hide-sm__n_Ecp",
	"visible-sm": "style_visible-sm__P2EKE",
	"visibleSm": "style_visible-sm__P2EKE",
	"hide-md": "style_hide-md__2DPYJ",
	"hideMd": "style_hide-md__2DPYJ",
	"visible-md": "style_visible-md__2OHkK",
	"visibleMd": "style_visible-md__2OHkK",
	"paperContent": "style_paperContent__382gV",
	"paperContentFlat": "style_paperContentFlat__QSsBj",
	"paperFullWidth": "style_paperFullWidth__8SfP3",
	"container": "style_container__23_qZ",
	"headerContainer": "style_headerContainer__1Wp7n",
	"busyFromPromise": "style_busyFromPromise__m7JN_",
	"title": "style_title__1zL1H",
	"stickied": "style_stickied__3AmB4"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/PaperLayout/style.less
// module id = 1419
// module chunks = 8